export const COMPLETED = [
    {
        images: ["seongdonggu-seongsudong-hallasigmavalley-1.jpg", 
                 "seongdonggu-seongsudong-hallasigmavalley-2.jpg"], 
        location: "서울특별시 성동구 성수동 2가",
        business_name: "서울숲 한라시그마벨리 아파트형공장",
        business_area: "3907.00",
        total_area: "33,965.49",
        purpose: "아파트형공장 및 지원시설"
    },    
]

export const IN_PROGRESS = [
    {
        images: ["songpagu-bangidong-urbanloft-1.jpg", 
                "songpagu-bangidong-urbanloft-2.jpg", 
                "songpagu-bangidong-urbanloft-3.jpg"], 
        location: "서울특별시 송파구 방이동",
        business_name: "어반로프트 올림픽파크",
        business_area: "986",
        total_area: "9,577",
        purpose: "오피스텔, 근린생활시설"
    },
    {
        images: ["gangdonggu-seongnaedong-redevelopment-1.jpg", 
                "gangdonggu-seongnaedong-redevelopment-2.jpg", 
                "gangdonggu-seongnaedong-redevelopment-3.jpg", 
                "gangdonggu-seongnaedong-redevelopment-4.jpg", 
                "gangdonggu-seongnaedong-redevelopment-5.jpg"], 
        location: "서울특별시 강동구 성내동",
        business_name: "성내3구역 도시정비형 재개발사업",
        business_area: "6,729",
        total_area: "72,000",
        purpose: "공동주택, 근린생활시설, 오피스, 오피스텔"
    },
]

export const PLANNED = [
    {
        images: ["gangdonggu-seongnaedong-station-activation-1.jpg", 
                "gangdonggu-seongnaedong-station-activation-2.jpg", 
                "gangdonggu-seongnaedong-station-activation-3.jpg"], 
        location: "서울특별시 강동구 성내동",
        business_name: "강동역 역세권 활성화 사업",
        business_area: "21,461.00",
        total_area: "140,582.63",
        purpose: "공동주택, 근린생활시설, 오피스, 오피스텔"
    },
]